var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "11px",
    viewBox: "0 0 6 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow_drop_down - right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "In/Out-Loblaws-Dac-Copy-2",
    transform: "translate(-1929.000000, -199.000000)",
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drive-in-card-Copy",
    transform: "translate(97.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table-core",
    transform: "translate(18.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trailer1",
    transform: "translate(1724.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trailer-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "arrow_drop_down---right",
    transform: "translate(93.016000, 9.409600) rotate(-90.000000) translate(-93.016000, -9.409600) ",
    points: "88 6.4 98.032 6.4 93.016 12.4192"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right_arrow_icon.b3e0d20ac4d50ab83965eb917d625549.svg";
export { ForwardRef as ReactComponent };